//var __discount_server = "https://mike-discount.skygdi.com";
var __discount_server = "https://mike-discount.hatsemb.com";
//var __discount_server = "https://shop-now.ngrok.io";
//var __cloud_name = "dez2z0qcy";
var __cloud_name = "hatsemb-com";


function getStarted(){
  window.location.href = "/pages/customized";
}

$(document).ready(function(){
  //Listen:
  window.addEventListener('__cart_updated', function(e){
    updateCartIcon();
  }, false);
});

var __items;
function myCheckout(){
  jQuery.getJSON('/cart.js', function(cart) {
    //console.log(cart);
    __items = cart.items;
    tryGetDiscountCheckoutURL();
  });
}

function tryGetDiscountCheckoutURL(){
  $.ajax({
    url : __discount_server+"/api/get_checkout_url",
    type: "POST",
    data: JSON.stringify({
      items: __items,
      note: $("#Cart-note").val()
    }),
    success: function(data, textStatus, jqXHR){
      if( data["checkout"]==null ) window.location.href = "/checkout";
      else{
        window.location.href = data["checkout"]["draft_order"]["invoice_url"];
      }
	  //console.log(data);
    },
    error: function (jqXHR, textStatus, errorThrown){
      
    }
  });
}

function updateCartIcon(){
  jQuery.getJSON('/cart.js', function(cart) {
    //console.log(cart);
    $(".cart-count-bubble").find("span").text( cart.item_count );
  });
}